import database from '../../firebase/firebase';

// Connect to segment analytics
import { EventTypes } from 'redux-segment';

import formatDate from '../../functions/formatDate';

import UserFactory from '../../classes/UserFactory';
import LocalStorage from '../../classes/LocalStorage';
import Estimation from '../../classes/Estimation';
import { setBikeDueDate } from '../actions/BikeActions';

const local = new LocalStorage();
const user = new UserFactory().createUser();

const identifyUser = ({ user }) => ({
    type: 'IDENTIFY_USER',
    user
});

const trackSegmentUser = ({ user }, { name }, { date, birth }, num, { subscribtion = true }, {params = null}) => {

    const birthMonthKey = `birthMonth_${num}`;
    const birthYearKey = `birthYear_${num}`;
    const birthISOKey = `birthISO_${num}`;

    let partnerName;

    if (params.partner) {
        partnerName = params.partner
    } else {
        partnerName = "Guardian"
    }

    const nameKey = `name_${num}`;

    return {
        type: 'TRACK_SEGMENT_USER',
        meta: {
            analytics: {
                eventType: EventTypes.identify,
                eventPayload: {
                    userId: user.id,
                    traits: {
                        email: user.email,
                        [nameKey]: name,
                        [birthMonthKey]: birth.birthMonth,
                        [birthYearKey]: birth.birthYear,
                        [birthISOKey]: date,
                        acceptsGuardianMarketing: subscribtion,
                        partner: partnerName
                    }
                },
            },
        },
    }
};

const identify = () => {

    // user visits counter
    user.visits = user.unique === 'yes' ? 0 : Number(local.get('guardianBikesUserVisits'));
    user.age = local.get('guardianBikesUserAge');
    local.set('guardianBikesUserVisits', user.visits);
    user.visits++;

    return (dispatch) => {
        dispatch(identifyUser({ user }));
    }
};

const setBikeWillLast = ({ willLast = {} }) => ({
    type: 'SET_BIKE_WILL_LAST',
    willLast
});

// Segment analytics meta
const setDayOfBirth = ({ date = '', birth = {} } = {}, userId) => ({
    type: 'SET_DAY_OF_BIRTH',
    date,
    birth
});

const setEmail = ({ email = '' }) => ({
    type: 'SET_EMAIL',
    email
});

const setName = ({ name = '' }, num) => {
    return {
        type: 'SET_NAME',
        name
    }

};

const pageParams = ({ params = {} }) => ({
    type: 'PAGE_PARAMS',
    params
})

const setPageParams = () => {

    const url = new URL(window.location.href);
    const urlParams = url.search.slice(1);

    const paramsArray = urlParams.split('&');

    const params = {};

    paramsArray.map(item => {
        const key = item.split('=')[0];
        const value = item.split('=')[1];

        params[key] = value;
        return params
    })

    return (dispatch) => {

        dispatch(pageParams({ params }))

    }
}

const setNameDatabase = ({ name = '' } = {}, num) => {

    return (dispatch) => {

        dispatch(setName({ name }, num));

        return database.ref(`user_${user.id}/user/name`).update({ name });
    }
};

const setDayOfBirthDatabase = ({ date = '' } = {}) => {
    return (dispatch, getValue) => {
        const userId = getValue().user.user.id;

        const birthMonth = formatDate(date, true).month;
        const birthYear = formatDate(date, true).year;

        const birth = {
            birthYear,
            birthMonth
        };

        // Update user info Segment
        user.dayOfBirth = local.save('guardianBikesUserDate', date);
        const fullAge = local.save('guardianBikesUserAge', new Estimation(date).getAge().months) / 12;
        user.age = parseFloat(fullAge.toFixed(1));

        // dispatch(identifyUser({ user }));

        dispatch(setDayOfBirth({ date, birth }, userId));

        return database.ref(`user_${user.id}/user/date`).update({ date, birth });
    }
};

const setUserInfo = (date, unit) => {


    return (dispatch, getValue) => {

        const bike = getValue().bike.bike;
        const color = bike.color;

        const estimation = new Estimation(date, bike.height);
        const age = estimation.getAge();
        const willLast = estimation.getWillLast(bike, unit, color);
        const willLastAge = willLast.age;
        const estimatedData = willLast.dinamic;

        const bikeDueDate = willLast.bikeDueDate;

        dispatch(setDayOfBirthDatabase({ date }));
        dispatch(setBikeWillLast({ willLast }));
        dispatch(setBikeDueDate({ bikeDueDate }));

        return database.ref(`user_${user.id}/user/date`).update({ age, willLastAge, estimatedData })

    }

};

const setEmailDatabase = ({ email = '' }) => {

    return (dispatch) => {

        // Update user info Segment
        user.email = local.save('guardianBikesUserEmail', email);
        dispatch(identifyUser({ user }));

        return database.ref(`user_${user.id}/user/email`).update({ email }).then(() => {
            dispatch(setEmail({ email }));
        })
    }

};

export {
    setUserInfo,
    identifyUser,
    setNameDatabase,
    identify,
    setDayOfBirth,
    setDayOfBirthDatabase,
    setEmail,
    setEmailDatabase,
    setBikeWillLast,
    trackSegmentUser,
    setPageParams,
    user
};


// WEBPACK FOOTER //
// ./src/redux/actions/UserActions.js